<!--Section for create folder -->
<form [formGroup]="form" (ngSubmit)="createFolderSubmit()" >
  <div id="createFolderSection">
    <div class="header-flex p-16 bottomBorderStyle">
      <h5 class="m-0 flex-grow-1">
        {{ isFromLoadTemplate ? dialogData.dialogTitle : 'Create a folder' }}
      </h5>
      @if (isFromLoadTemplate) {
        <button
          mat-icon-button
          (click)="closeDialog()"
          type="button"
          class="close-button"
          id="bucket-items-create-folder-btn-close"
          >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
    @if (isFromLoadTemplate && dialogData?.templateName) {
      <div class="p-16 bg-light-gray border-bottom">
        <small class="text-muted">Using template: <strong>{{ dialogData.templateName }}</strong></small>
      </div>
    }
    <div class="createFolderContent input-min-spacing p-16">
      <mat-form-field id="folderNameField" class="m-b-m w-100">
        <mat-label>{{ isFromLoadTemplate && isStudyPackageFolder ? 'Study Code' : 'Folder Name' }}</mat-label>
        <input
          matInput
          [placeholder]="isFromLoadTemplate && isStudyPackageFolder ? 'eg. S22-XXXXX' : 'Enter a folder name'"
          formControlName ="folderName"
          id="bucket-items-create-folder-fld-name"
          />
          @if (form.controls.folderName.errors?.required) {
            <mat-error>
              {{ isFromLoadTemplate && isStudyPackageFolder ? 'Study Code is a mandatory field.' : 'Folder Name is a mandatory field.' }}
            </mat-error>
          }
          @if (form.controls.folderName.errors?.maxlength) {
            <mat-error>
              {{ isFromLoadTemplate && isStudyPackageFolder ? 'Study Code cannot have more than 150 characters' : 'Folder name cannot have more than 150 characters' }}
            </mat-error>
          }
          @if (form.controls.folderName.errors?.pattern) {
            <mat-error>
              {{ isFromLoadTemplate && isStudyPackageFolder ? 'Study Code must not contain special characters: / : * ? \\ \" < > |' : 'Folder name must not contain special characters: / : * ? \\ \" < > |' }}
            </mat-error>
          }
          @if (form.controls.folderName.errors?.inValidStudyPackageFolderName) {
            <mat-error>
              Please enter valid Study code
            </mat-error>
          }
          @if (form.controls.folderName.errors?.inValidFacilityPackageFolderName) {
            <mat-error>
              {{ isFromLoadTemplate && isStudyPackageFolder ? 'Please enter valid Study code' : 'Folder name cannot have Study Code structure' }}
            </mat-error>
          }
        </mat-form-field>
        <div class="d-flex gap-4">
          <button
            id="bucket-items-create-folder-btn-submit"
            mat-button
            type="submit"
            [class]="isFromLoadTemplate ? 'ghost flex-grow-1 orange-button' : 'ghost flex-grow-1 blue-button'"
            [disabled]="submitButtonClicked"
            >
            Submit
          </button>
          @if (isFromLoadTemplate) {
            <button
              mat-button
              type="button"
              class="ghost flex-grow-1"
              (click)="closeDialog()"
              id="bucket-items-create-folder-btn-cancel"
              >
              Cancel
            </button>
          }
        </div>
      </div>
    </div>
  </form>


